import axios from 'axios';
import { apiMainUrl } from '../apiConfig';

const API_BASE_URL = apiMainUrl + 'DashboardAssistant';

const chat = async (prompt, token, globalFilters = {}, tileId, outputType = 'chart') => {
    try {
        const response = await axios.post(`${API_BASE_URL}/chat`, { prompt, globalFilters, tileId, outputType }, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error invoking dashboard assistant chat:', error);
        throw error;
    }
};

const save = async (payload, token) => {
    try {
        const response = await axios.post(`${API_BASE_URL}`, payload, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error saving dashboard assistant data:', error);
        throw error;
    }
};

const update = async (dashboardId, payload, token) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/${dashboardId}`, payload, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error updating dashboard assistant data:', error);
        throw error;
    }
};

const load = async (dashboardId, token) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/${dashboardId}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error loading dashboard assistant data:', error);
        throw error;
    }
};

const list = async (token) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/list`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error listing dashboard assistant entries:', error);
        throw error;
    }
};

const remove = async (dashboardId, token) => {
    try {
        const response = await axios.delete(`${API_BASE_URL}/${dashboardId}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.status >= 200 && response.status < 300;
    } catch (error) {
        console.error('Error deleting dashboard assistant entry:', error);
        throw error;
    }
};

const reload = async (dashboardId, token) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/${dashboardId}/reload`, {}, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error reloading dashboard data:', error);
        throw error;
  }
};

const uploadImage = async (file, token) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    const response = await axios.post(`${API_BASE_URL}/upload`, formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data; // expect { url }
  } catch (error) {
    console.error('Error uploading image:', error);
    throw error;
  }
};

export const DashboardAssistantDataService = {
    chat,
    save,
    update,
    load,
    list,
    delete: remove,
    details: load,
    reload,
    uploadImage
};
